import { useEffect, useState } from 'react';
import { useAppStore } from './store';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { Editor } from './components/Editor';
import { Preview } from './components/Preview';
import { PromptInput } from './components/PromptInput';
import { WelcomeScreen } from './components/WelcomeScreen';
import { Terminal } from './components/Terminal';

export default function App() {
    const { setProject, files, showSidebar, connectWebSocket, fetchProjects, createProject, loadProject } = useAppStore();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const initApp = async () => {
            try {
                await fetchProjects();
                const latestProjects = useAppStore.getState().projects;
                if (latestProjects.length > 0) {
                    await loadProject(latestProjects[latestProjects.length - 1].id);
                } else {
                    await createProject('My First Vibe');
                }
            } catch (error) {
                console.error('Failed to init app:', error);
            } finally {
                setIsLoading(false);
            }
        };

        initApp();
    }, []);

    if (isLoading) {
        return (
            <div className="h-screen flex items-center justify-center bg-background">
                <div className="flex flex-col items-center gap-4">
                    <div className="w-12 h-12 rounded-full border-2 border-accent-primary border-t-transparent animate-spin" />
                    <p className="text-text-secondary">Starting Vibeflare...</p>
                </div>
            </div>
        );
    }

    const hasContent = files.size > 0;

    return (
        <div className="h-screen flex flex-col overflow-hidden bg-grid">
            {/* Header */}
            <Header />

            {/* Main content area */}
            <div className="flex-1 flex overflow-hidden">
                {/* Sidebar */}
                {showSidebar && <Sidebar />}

                {/* Editor + Preview */}
                <div className="flex-1 flex overflow-hidden">
                    {hasContent ? (
                        <>
                            {/* Code Editor */}
                            <div className="w-1/2 flex flex-col overflow-hidden border-r border-border">
                                <Editor />
                            </div>

                            {/* Preview */}
                            <div className="w-1/2 flex flex-col overflow-hidden">
                                <Preview />
                            </div>
                        </>
                    ) : (
                        /* Welcome screen when no content */
                        <WelcomeScreen />
                    )}
                </div>
            </div>

            {/* Bottom prompt input */}
            <PromptInput />

            {/* Sandbox Terminal */}
            <Terminal />
        </div>
    );
}
